import { Accordion } from '@mantine/core';
import { useStoreMap } from 'effector-react';
import { ReactNode } from 'react';
import { Device, Player } from 'shared/api';
import { gamePageModel } from '../../model';
import { GamePageActiveIndicator } from '../game-page-active-indicator';
import { GamePagePlayer } from '../game-page-player';
import cls from './game-page-device.module.scss';

export type GamePageDeviceProps = {
	deviceId: number;
	actionSlot: (device: Device) => ReactNode;
	playerActionSlot: (player: Player) => ReactNode;
};

export const GamePageDevice = ({ deviceId, actionSlot, playerActionSlot }: GamePageDeviceProps) => {
	const device = useStoreMap({
		store: gamePageModel.$devices,
		keys: [deviceId],
		fn: (devices, [dvcId]) => devices.find((dvc) => dvc.id === dvcId)!,
	});

	return (
		<Accordion.Item
			key={device.name}
			value={device.name}
			className={cls.gamePageDeviceItem}
		>
			<Accordion.Control
				data-test-id={`game-page-device-${device.id}`}
				classNames={{
					control: cls.gamePageDeviceControl,
				}}
			>
				<span className={cls.gamePageDeviceLabel}>
					<span className={cls.gamePageDeviceLabelName}>{device.name}</span>
					<GamePageActiveIndicator active={device.isActive} />
				</span>
				<div className={cls.gamePageDeviceLabelActions}>{actionSlot(device)}</div>
			</Accordion.Control>
			<Accordion.Panel>
				{[...device.players]
					.sort((a, b) => a.order - b.order)
					.map((player) => (
						<GamePagePlayer
							key={player.id}
							player={player}
							actionSlot={playerActionSlot}
						/>
					))}
			</Accordion.Panel>
		</Accordion.Item>
	);
};
